import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { EVENTO_NAV_SECTIONS } from "./eventoDetalleConstants";
import "./EventoTopNav.css";
import iconDatosGeologicosV3 from "../../../assets/images/icons/icono-datos-geologicos-v3.svg";

export default function EventoTopNav({
  mainTab,
  setMainTab,
  subIH,
  setSubIH,
  subDG,
  setSubDG,
  subMM,
  setSubMM,
  volcanId,
  eventoId,
  sections = EVENTO_NAV_SECTIONS,
}) {
  const [openKey, setOpenKey] = useState(null);
  const navRef = useRef(null);
  const closeTimer = useRef(null);

  const clearCloseTimer = () => {
    if (closeTimer.current) {
      window.clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const scheduleClose = () => {
    clearCloseTimer();
    closeTimer.current = window.setTimeout(() => setOpenKey(null), 160);
  };

  useEffect(() => {
    return () => clearCloseTimer();
  }, []);

  useEffect(() => {
    function onDocClick(e) {
      if (!navRef.current?.contains(e.target)) setOpenKey(null);
    }
    function onKey(e) {
      if (e.key === "Escape") setOpenKey(null);
    }
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const pickSubSetter = (sectionKey) => {
    if (sectionKey === "informacion_historica") return setSubIH;
    if (sectionKey === "datos_geologicos") return setSubDG;
    if (sectionKey === "multimedia") return setSubMM;
    return null;
  };

  const isSubActive = (sectionKey, childKey) => {
    if (mainTab !== sectionKey) return false;
    if (sectionKey === "informacion_historica") return subIH === childKey;
    if (sectionKey === "datos_geologicos") return subDG === childKey;
    if (sectionKey === "multimedia") return subMM === childKey;
    return false;
  };

  const onSelectChild = (sectionKey, childKey) => {
    setMainTab(sectionKey);
    const setSub = pickSubSetter(sectionKey);
    if (setSub) setSub(childKey);
    setOpenKey(null);
  };

  const toSection = (sectionKey) => {
    const base = `/evento-detalle?volcanId=${encodeURIComponent(String(volcanId))}&eventoId=${encodeURIComponent(String(eventoId))}`;
    if (!sectionKey) return base;
    return `${base}&section=${encodeURIComponent(sectionKey)}`;
  };

  const toChild = (sectionKey, childKey) => {
    const base = toSection(sectionKey);
    if (!childKey) return base;
    return `${base}&sub=${encodeURIComponent(childKey)}`;
  };

  return (
    <nav ref={navRef} className="evt-top-nav" aria-label="Secciones del evento">
      <div className="evt-top-nav-inner" role="menubar">
        {(Array.isArray(sections) ? sections : EVENTO_NAV_SECTIONS).map(
          (section, idx) => {
            const hasChildren =
              Array.isArray(section.children) && section.children.length > 0;

            if (!hasChildren) {
              return (
                <React.Fragment key={section.key}>
                  {idx > 0 ? (
                    <span className="evt-top-nav-sep" aria-hidden />
                  ) : null}
                  <div className="evt-top-nav-item">
                    <Link
                      to={toSection(section.key)}
                      role="menuitem"
                      className={`evt-top-nav-link${mainTab === section.key ? " is-active" : ""}`}
                      onClick={() => {
                        setMainTab(section.key);
                        setOpenKey(null);
                      }}
                    >
                      {section.icon ? (
                        <i
                          className={`bi ${section.icon} evt-top-nav-ico`}
                          aria-hidden
                        />
                      ) : null}
                      <span className="evt-top-nav-label">{section.label}</span>
                    </Link>
                  </div>
                </React.Fragment>
              );
            }

            const ddOpen = openKey === section.key;

            return (
              <React.Fragment key={section.key}>
                {idx > 0 ? (
                  <span className="evt-top-nav-sep" aria-hidden />
                ) : null}
                <div
                  className={`evt-top-nav-item evt-top-nav-item--dropdown${ddOpen ? " is-open" : ""}`}
                  onMouseEnter={() => {
                    clearCloseTimer();
                    setOpenKey(section.key);
                  }}
                  onMouseLeave={scheduleClose}
                >
                  <button
                    type="button"
                    role="menuitem"
                    aria-haspopup="true"
                    aria-expanded={ddOpen}
                    className={`evt-top-nav-link${mainTab === section.key ? " is-active" : ""}`}
                    onClick={() => setOpenKey(ddOpen ? null : section.key)}
                  >
                    {section.icon ? (
                      <i
                        className={`bi ${section.icon} evt-top-nav-ico`}
                        aria-hidden
                      />
                    ) : null}
                    <span className="evt-top-nav-label">{section.label}</span>
                    <span className="evt-top-nav-caret" aria-hidden />
                  </button>
                  <div className="evt-top-nav-dropdown" role="menu">
                    {section.children.map((child) => (
                      <Link
                        key={child.key}
                        to={toChild(section.key, child.key)}
                        role="menuitem"
                        className={`evt-top-nav-dd-item${isSubActive(section.key, child.key) ? " is-active" : ""}`}
                        onClick={() => onSelectChild(section.key, child.key)}
                      >
                        {section.key === "datos_geologicos" &&
                        child.key === "parametros" ? (
                          <img
                            src={iconDatosGeologicosV3}
                            alt=""
                            className="evt-top-nav-dd-ico evt-top-nav-dd-ico--img"
                            aria-hidden
                          />
                        ) : child.icon ? (
                          <i
                            className={`bi ${child.icon} evt-top-nav-dd-ico`}
                            aria-hidden
                          />
                        ) : null}
                        <span className="evt-top-nav-dd-text">
                          {child.label}
                        </span>
                      </Link>
                    ))}
                  </div>
                </div>
              </React.Fragment>
            );
          },
        )}
      </div>
    </nav>
  );
}
